/**
 * Centralized date formatting utilities.
 * Standard format: DD/MM/YYYY  (e.g. 07/01/2026)
 * All date display in the app MUST use these helpers.
 */

/**
 * Format a date value as DD/MM/YYYY
 * @param value - Date object, ISO string, or any parseable date value
 * @returns Formatted date string like "07/01/2026", or "-" for invalid/null
 */
export function formatDate(value: Date | string | number | null | undefined): string {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "-";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

/**
 * Format a date-time value as DD/MM/YYYY HH:MM:SS AM/PM
 * @param value - Date object, ISO string, or any parseable date value
 * @returns Formatted datetime string like "07/01/2026 04:06:10 PM", or "-" for invalid/null
 */
export function formatDateTime(value: Date | string | number | null | undefined): string {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "-";
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const seconds = String(d.getSeconds()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${day}/${month}/${year} ${String(hours).padStart(2, "0")}:${minutes}:${seconds} ${ampm}`;
}

/**
 * Format a date for display in User Log Details column
 * e.g. "Super Admin 07/01/2026 04:06:10 PM"
 */
export function formatUserLog(
  userName: string | null | undefined,
  dateValue: Date | string | number | null | undefined
): string {
  const name = userName || "Super Admin";
  const dt = formatDateTime(dateValue);
  if (dt === "-") return "";
  return `${name} ${dt}`;
}
